/**
 * TanStack Query hooks for `campaign-description`. Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	list,
	remove,
	campaignDescriptionQueryKeys,
	type CreateCampaignDescriptionBody,
	type ListCampaignDescriptionResponse,
	type CampaignDescriptionRow,
} from "./api";

export function useCampaignDescriptionList(): UseQueryResult<ListCampaignDescriptionResponse, Error> {
	return useQuery({
		queryKey: campaignDescriptionQueryKeys.list(),
		queryFn: list,
	});
}

export function useCampaignDescriptionCreate(): UseMutationResult<CampaignDescriptionRow, Error, CreateCampaignDescriptionBody> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: campaignDescriptionQueryKeys.all });
		},
	});
}

export function useCampaignDescriptionDelete(): UseMutationResult<{ removed: boolean }, Error, string> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: remove,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: campaignDescriptionQueryKeys.all });
		},
	});
}
